'use client';
import FormControlLabel from "./FormControlLabel.js";
export default FormControlLabel;